/**
 * Demo data used when the accounting endpoints aren't deployed yet - delete once the API is live.
 * Manifests use the shape returned by POST /api/accounting/manifests/upload (Route Sheets Report PDF).
 */
export const SAMPLE_DRIVERS = [
  { id: 'DRV-8842', name: "Philippe D'Amours" },
  { id: 'DRV-8790', name: 'Karim Benali' },
  { id: 'DRV-8811', name: 'Sophie Tremblay' },
];

const sampleDriverCard = (driver, zones) => ({
  driverId: driver.id,
  driverName: driver.name,
  zones,
  weightTiers: [
    { code: 'FURNITURE', label: 'Furniture 50–99.99 lb', minLb: 50, mode: 'add', amount: 2.0 },
    { code: 'FURNITURE_2X', label: '2× Furniture 100+ lb', minLb: 100, mode: 'add', amount: 4.0 },
  ],
});

// Sophie Tremblay intentionally has no card, to demo the "no driver rate card" block.
export const SAMPLE_DRIVER_CARDS = {
  'DRV-8842': sampleDriverCard(SAMPLE_DRIVERS[0], { 1: 1.5, 2: 2.6, 3: null, 4: 1.4, 5: 1.45, 6: 1.7, 7: 2.1 }),
  'DRV-8790': sampleDriverCard(SAMPLE_DRIVERS[1], { 1: 1.55, 2: 2.5, 3: null, 4: 1.4, 5: 1.5, 6: 1.75, 7: 2.0 }),
};

export const SAMPLE_MANIFESTS = [
  {
    id: 'MNF-20261016-031150',
    route: 'SLMT-AMZ-C01',
    location: 'Montreal',
    hub: 'Amazon YUL Sortation (Montreal, QC)',
    date: '2026-10-16T03:11:50',
    driver: { id: 'DRV-8842', name: 'Philippe D\'Amours' },
    status: 'parsed',
    sourceFile: 'route_sheet_SLMT-AMZ-C01_2026-10-16.pdf',
    declared: { pieces: 208, groups: 192, weightLb: 359.75, volumeIn3: 551203.73 },
    stops: [
      { id: '1', name: "philippe d'amours", address: '22 rue des Censitaires, Saint-Jean-Sur-Richelieu, QC, J2W1B9', service: 'Amazon Freight', pieces: [{ barcode: 'ASL0071253668', weightLb: 0.84, volumeCm3: 1940.72 }] },
      { id: '2', name: 'chantal dulude', address: '17 rue des Censitaires, St-Jean-Sur-Richelieu, QC, J2W1B9', service: 'Amazon Freight', pieces: [{ barcode: 'ASL0071214029', weightLb: 1.15, volumeCm3: 3542.4 }, { barcode: 'ASL0071237417', weightLb: 1.07, volumeCm3: 1648.51 }] },
      { id: '3', name: 'Guy Lanoue', address: '6476 rue Mailloux, La Prairie, QC, J5R0L1', service: 'Amazon Freight', pieces: [{ barcode: 'ASL0071220485', weightLb: 0.47, volumeCm3: 1451.86 }] },
      { id: '4', name: 'Emmy Cardinal', address: '74 9ieme rue, St jean sur Richelieu, QC, J2Y1A5', service: 'Amazon Freight', pieces: [{ barcode: 'ASL0071245817', weightLb: 0.55, volumeCm3: 1240.29 }] },
      { id: '6', name: 'Melissa Haineault', address: '58 9E rue, St-Jean-sur-Richelieu, QC, J2Y1A5', service: 'Amazon Freight', pieces: [{ barcode: 'ASL0071214734', weightLb: 0.88, volumeCm3: 765.03 }] },
      { id: '7', name: 'Olivier Tetreault inc.', address: '1357 rue des Roches, Saint-Jean-sur-Richelieu, QC, J2W1A8', service: 'Amazon Freight', pieces: [{ barcode: 'ASL0071221317', weightLb: 1.05, volumeCm3: 5728.92 }] },
      { id: '8', name: 'Helene Larouche', address: '21 du nevada, St-Jean-sur-Richelieu, QC, J2Y1A5', service: 'Amazon Freight', pieces: [{ barcode: 'ASL0071261257', weightLb: 6.35, volumeCm3: 16468.67 }] },
      { id: '9', name: 'Marc Bouchard', address: '140 boul. Taschereau, La Prairie, QC, J5R5H6', service: 'Amazon Freight', pieces: [{ barcode: 'ASL0071271120', weightLb: 62.4, volumeCm3: 98500.0 }] },
      { id: '10', name: 'Studio Leduc', address: '88 rue Principale, Longueuil, QC, J4H3L2', service: 'Amazon Freight', pieces: [{ barcode: 'ASL0071271999', weightLb: 18.2, volumeCm3: 1450000.0 }] },
      { id: '11', name: 'Nadia Roy', address: '9 rue Champlain, Chambly, QC, J3L2R5', service: 'Amazon Freight', pieces: [{ barcode: 'ASL0071280014', weightLb: 2.1, volumeCm3: 4100.0 }] },
    ],
  },
  {
    id: 'MNF-20261016-040212',
    route: 'SLMT-AMZ-C02',
    location: 'Montreal',
    hub: 'Amazon YUL Sortation (Montreal, QC)',
    date: '2026-10-16T04:02:12',
    driver: { id: 'DRV-8790', name: 'Karim Benali' },
    status: 'posted',
    postedAt: '2026-10-16T18:20:00',
    sourceFile: 'route_sheet_SLMT-AMZ-C02_2026-10-16.pdf',
    declared: { pieces: 3, groups: 3, weightLb: 4.2, volumeIn3: 610 },
    stops: [
      { id: '1', name: 'Julie Martin', address: '300 rue Saint-Paul, Montreal, QC, H2Y1H4', service: 'Amazon Freight', pieces: [{ barcode: 'ASL0071300001', weightLb: 1.2, volumeCm3: 2100 }] },
      { id: '2', name: 'Pierre Gagnon', address: '55 av. du Parc, Montreal, QC, H2W2N3', service: 'Amazon Freight', pieces: [{ barcode: 'ASL0071300002', weightLb: 2.0, volumeCm3: 3900 }] },
      { id: '3', name: 'Cafe Olimpico', address: '124 rue St-Viateur, Montreal, QC, H2T1A1', service: 'Amazon Freight', pieces: [{ barcode: 'ASL0071300003', weightLb: 1.0, volumeCm3: 4000 }] },
    ],
  },
  {
    id: 'MNF-20261015-033005',
    route: 'SLMT-AMZ-C03',
    location: 'Montreal',
    hub: 'Amazon YUL Sortation (Montreal, QC)',
    date: '2026-10-15T03:30:05',
    driver: null,
    status: 'parsed',
    sourceFile: 'route_sheet_SLMT-AMZ-C03_2026-10-15.pdf',
    declared: { pieces: 4, groups: 3, weightLb: 121.6, volumeIn3: 9400 },
    stops: [
      { id: '1', name: 'Marie-Eve Pelletier', address: '410 rue Beaubien E, Montreal, QC, H2S1S1', service: 'Amazon Freight', pieces: [{ barcode: 'ASL0071400101', weightLb: 3.4, volumeCm3: 6100 }] },
      { id: '2', name: 'Atelier Vrac', address: '2020 rue Ontario E, Montreal, QC, H2K1V5', service: 'Amazon Freight', pieces: [{ barcode: 'ASL0071400102', weightLb: 104.0, volumeCm3: 140000 }, { barcode: 'ASL0071400103', weightLb: 12.2, volumeCm3: 22000 }] },
      { id: '3', name: 'Luc Fortin', address: '77 rue King, Sherbrooke, QC, J1H1P8', service: 'Amazon Freight', pieces: [{ barcode: 'ASL0071400104', weightLb: 2.0, volumeCm3: 3000 }] },
    ],
  },
  {
    id: 'MNF-20261014-031522',
    route: 'SLMT-AMZ-C01',
    location: 'Montreal',
    hub: 'Amazon YUL Sortation (Montreal, QC)',
    date: '2026-10-14T03:15:22',
    driver: { id: 'DRV-8842', name: "Philippe D'Amours" },
    status: 'posted',
    postedAt: '2026-10-14T19:05:00',
    sourceFile: 'route_sheet_SLMT-AMZ-C01_2026-10-14.pdf',
    declared: { pieces: 4, groups: 4, weightLb: 9.9, volumeIn3: 820 },
    stops: [
      { id: '1', name: 'Denis Lavoie', address: '12 rue Jacques-Cartier, Saint-Jean-sur-Richelieu, QC, J2W2A1', service: 'Amazon Freight', pieces: [{ barcode: 'ASL0071190001', weightLb: 2.3, volumeCm3: 3300 }] },
      { id: '2', name: 'Annie Roy', address: '90 boul. du Séminaire N, Saint-Jean-sur-Richelieu, QC, J3B5L1', service: 'Amazon Freight', pieces: [{ barcode: 'ASL0071190002', weightLb: 1.6, volumeCm3: 2500 }] },
      { id: '3', name: 'Clinique Santé Plus', address: '305 rue Saint-Georges, La Prairie, QC, J5R2K7', service: 'Amazon Freight', pieces: [{ barcode: 'ASL0071190003', weightLb: 4.1, volumeCm3: 5200 }] },
      { id: '4', name: 'Eric Gauthier', address: '8 rue Lemoyne, Longueuil, QC, J4H1T4', service: 'Amazon Freight', pieces: [{ barcode: 'ASL0071190004', weightLb: 1.9, volumeCm3: 2400 }] },
    ],
  },
];
